import React, { useCallback, useMemo, useState } from "react";

export default function useConfirmDialog() {
  const [dialog, setDialog] = useState(null);

  const confirm = useCallback((options = {}) => {
    return new Promise((resolve) => {
      setDialog({
        title: options.title || "Please confirm",
        message: options.message || "Are you sure you want to continue?",
        confirmText: options.confirmText || "Confirm",
        cancelText: options.cancelText || "Cancel",
        danger: !!options.danger,
        resolve,
      });
    });
  }, []);

  const close = useCallback(
    (accepted) => {
      if (!dialog) return;
      dialog.resolve(!!accepted);
      setDialog(null);
    },
    [dialog]
  );

  const dialogNode = useMemo(() => {
    if (!dialog) return null;
    return (
      <div className="fixed inset-0 z-[100120] flex items-center justify-center bg-black/45 p-4">
        <div className="w-full max-w-md rounded-xl border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] p-4 shadow-xl">
          <h3 className="text-sm font-semibold text-[hsl(var(--ds-fg))]">{dialog.title}</h3>
          <p className="mt-2 text-sm text-[hsl(var(--ds-muted-fg))]">{dialog.message}</p>
          <div className="mt-4 flex justify-end gap-2">
            <button
              type="button"
              className="rounded border border-[hsl(var(--ds-border))] px-3 py-1.5 text-xs font-medium"
              onClick={() => close(false)}
            >
              {dialog.cancelText}
            </button>
            <button
              type="button"
              className={`rounded px-3 py-1.5 text-xs font-medium text-white ${
                dialog.danger ? "bg-[hsl(var(--ds-danger))]" : "bg-[hsl(var(--ds-primary))]"
              }`}
              onClick={() => close(true)}
            >
              {dialog.confirmText}
            </button>
          </div>
        </div>
      </div>
    );
  }, [close, dialog]);

  return { confirm, dialogNode };
}
